var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_377_3003)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8926 0.482422C15.5801 0.482422 14.2676 0.482422 12.9551 0.482422C12.2759 0.687295 11.895 1.14433 11.8125 1.85352C11.8065 3.03178 11.619 4.18023 11.25 5.29883C11.1897 5.67075 11.2483 6.02231 11.4258 6.35352C11.9984 7.0945 12.5668 7.83862 13.1309 8.58594C12.3244 10.166 11.2112 11.4902 9.79102 12.5586C9.25302 12.9321 8.69639 13.2779 8.12109 13.5957C7.4121 13.0508 6.70314 12.5059 5.99414 11.9609C5.72706 11.7916 5.4341 11.7037 5.11523 11.6973C4.45978 11.8435 3.80352 11.99 3.14648 12.1367C2.48164 12.2298 1.81367 12.2884 1.14258 12.3125C0.561974 12.4771 0.18696 12.8463 0.0175781 13.4199C0.0175781 14.7324 0.0175781 16.0449 0.0175781 17.3574C0.193359 17.9316 0.568371 18.3066 1.14258 18.4824C1.5879 18.4824 2.03319 18.4824 2.47852 18.4824C8.23911 17.9608 12.6512 15.2655 15.7148 10.3965C17.0704 8.09087 17.838 5.60648 18.0176 2.94336C18.0176 2.49805 18.0176 2.05274 18.0176 1.60742C17.8418 1.0332 17.4668 0.658203 16.8926 0.482422Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_377_3003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 18 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.f245acc4302c1cc814e6580d0db2b2b7.svg";
export { ForwardRef as ReactComponent };